import {
  FDHeadlineText, FDImage,
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dataAttrs } from 'Helpers/Testing';
import { BorderedTransparentBox } from 'Packages/FacetDesign/Components/Experimental/BorderedTransparentBox';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg', align: 'center' },
  }, overrideReadOnly);

export const ExploreAssumptionsItem = ({ resource }) => {
  const { loadModalCollectionByLink } = useModalContext();

  if (!resource) {
    return null;
  }

  return (
    <BorderedTransparentBox padding={2} color={'info'} flex={1}>
      <FDStack
        alignItems={'center'}
        spacing={2}
        justifyContent={'center'}
        paddingY={4}
        paddingX={2}
        height={'100%'}
        direction={'column'}
        {...dataAttrs('explore-assumptions-item')}
      >
        {resource.withRelationship(fr.relationships.image.name,
          (rel) => <FDImage alt={''} src={rel.link('related').url()} rounded={false} />,
          () => null)}
        <MetaControl attrName={'title'} metaOverrideSet={metaOverrides} resource={resource} />
        {resource.withRelationship(fr.relationships.details.name, (rel) => (<FDPrimaryActionButton
          label={rel.meta('prompt')}
          onClick={() => {
            loadModalCollectionByLink(rel.link('related').url());
          }}
          {...dataAttrs('explore-assumptions-item-details-button')}
        />), () => null)}
      </FDStack>
    </BorderedTransparentBox>
  );
};

ExploreAssumptionsItem.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
